import { render } from "./BlogItem.vue?vue&type=template&id=22e4e7f3&scoped=true"
import script from "./BlogItem.vue?vue&type=script&lang=js"
export * from "./BlogItem.vue?vue&type=script&lang=js"

import "./BlogItem.vue?vue&type=style&index=0&id=22e4e7f3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e4e7f3"]])

export default __exports__